<template>
    <v-img
        :lazy-src="data.image.sizes.thumbnail"
        lazy
        :src="data.image.sizes.full"
        cover
        :gradient="gradientColor[data.gradient]"
        :alt="data.image.title+' - '+data.image.description"
        class="mx-auto"
    >
        <v-container fluid class="fill-height pa-0">
            <v-row no-gutters class="fill-height ">
                <v-col cols="12"  align-self="start" class="text-start">
                   <v-container>
                    <h3 class="text-h3 text-lg-h2" v-html="data.title"></h3>
                    <h5 class="text-h5 text-lg-h4" v-if="data.sub_title" v-html="data.sub_title"></h5>
                   </v-container>
                </v-col>
                <v-col cols="12">
                    <v-container>
                        <v-responsive :aspect-ratio="4/3" class=" pa-4 d-block d-lg-none"></v-responsive>
                    </v-container>
                </v-col>
                <v-col cols="12"  align-self="end" class="text-start">
                    <v-row no-gutters align="center">
                        <v-col cols="12" >
                            <v-progress-linear role="progressbar" id="line-001" :aria-label="data.title" height="2" color="primary" model-value="100"></v-progress-linear>
                        </v-col>
                        <v-col cols="12" v-for="(item, index) in data.list" :key="index" >
                           <v-container>
                            <h4 class="text-h5 text-md-h4" v-if="item.title">{{ item.title }}</h4>
                            <h5 class="text-h6 text-md-h5" v-if="item.text">{{ item.text }}</h5>
                           </v-container>
                            <v-progress-linear role="progressbar" :id="'line-'+index" :aria-label="item.title" height="2" color="primary" model-value="100"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </v-img>
</template>

<script>
export default{
    props:{
        data:{
            required: true,
            type: Object,
        }
    },
    data: () => ({
        gradientColor:{
            black: "to bottom, rgba(0,0,0,1),rgba(0,0,0,1), rgba(0,0,0,0.2), rgba(0,0,0,0.0),rgba(0,0,0,0.0),rgba(0,0,0,0.0), rgba(0,0,0,0.2),  rgba(18,18,18,0.51), rgba(18,18,18,1), rgba(0,0,0,1)",
            white: "to bottom, rgba(255,255,255,1), rgba(255,255,255,1), rgba(255,255,255,0.51), rgba(255,255,255,0.31), rgba(255,255,255,0.1), rgba(255,255,255,0.0), rgba(255,255,255,0.0), rgba(255,255,255,0.2),  rgba(255,255,255,0.51), rgba(255,255,255,1)",
            primary: "to bottom, rgba(179,148,127,1), rgba(179,148,127,1), rgba(179,148,127,0.51), rgba(179,148,127,0.31), rgba(179,148,127,0.1), rgba(179,148,127,0.0), rgba(179,148,127,0.0), rgba(179,148,127,0.2),  rgba(179,148,127,0.51), rgba(179,148,127,1)"
        }
    })
}
</script>